import Vue from 'vue';

class EventBusVue extends Vue {
    public readonly REFRESH_ORDERS_LIST: string = 'refreshOrdersList';
    public readonly UPDATE_SEARCH: string = 'updateSearch';
    public readonly CHANGE_ORDER_STATE: string = 'changeOrderState';
    public readonly TOGGLE_DISPLAY: string = 'toggleDisplay';
    public readonly TOGGLE_FOLDING: string = 'toggleFolding';
    public readonly REFRESH_ORDERED_PRODUCTS_LIST: string = 'refreshOrderedProductsList';
    public readonly CHANGE_ORDERED_PRODUCT_STATE: string = 'changeOrderedProductState';
    public readonly UPDATE_FILTER_WITH_DELAY: string = 'updateFilterWithDelay';
    public readonly UPDATE_FILTER_WITH_MISSING: string = 'updateFilterWithMissing';
    public readonly UPDATE_FILTER_WITH_CATERING_SERVICE: string = 'updateFilterWithCateringService';
    public readonly PREPARE_ORDER: string = 'prepareOrder';
    public readonly CANCEL_ORDER_PREPARATION: string = 'cancelOrderPreparation';

    public readonly UPDATE_SELECTED_ZONES: string = 'updateSelectedZones';
    public readonly UPDATE_SELECTED_RANGE: string = 'updateSelectedRange';
    public readonly UPDATE_SELECTED_PRODUCT: string = 'updateSelectedProduct';

    public readonly REFRESH_ALERT_SETTINGS: string = 'refreshAlertSettings';
    public readonly SHOW_DELETE_EMAIL_FORM: string = 'showDeleteEmailForm';

    public readonly EDIT_SCANNABLE_PRODUCT: string = 'editScannableProduct';

    // History events
    public readonly HISTORY_FILTER_CHANGE: string = 'historyFilterChange';
    public readonly HISTORY_SEARCH_TERMS_CHANGE: string = 'historySearchTermsChange';
    public readonly HISTORY_EXPORT: string = 'historyExport';

    public readonly REFRESH_STORE_ID: string = 'refreshStoreId';

    public readonly UPDATE_PRODUCT_OUT_OF_STOCK_STATUS: string = 'updateProductOutOfStockStatus';
    public readonly UPDATE_ORIGIN: string = 'updateProductOrigin';

    public readonly REFRESH_STORE: string = 'refreshStore';

    // Server-sent events
    public readonly ORDERS_LIST_SERVER_UPDATE: string = 'ordersListServerUpdate';
}

export const EventBus = new EventBusVue();